import meldingenApi from "../../api/meldingenApi";
import mergeDeep from "../../util/mergeDeep";
import generateGuid from "../../util/guid";
import FilesHelper from "../common/FilesHelper";
import moment from "moment";

export default class MeldingenPageHelper {
    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const meldingId = generateGuid();
        this.context.filesHelper = new FilesHelper(this.context, null);

        let model = mergeDeep({}, this.context.state.meldingenModel);
        model.id = meldingId;
        model.datum = moment().format("DD-MM-YYYY");

        this.context.setState({
            meldingenModel: model
        });
    }

    change(event) {
        const property = event.target.name;
        const value = event.target.value;

        let model = mergeDeep({}, this.context.state.meldingenModel);
        model[property] = value;

        this.context.setState({
			meldingenModel: model
        });
    }

	changeCheckbox(event) {
		const property = event.target.name;
		const value = event.target.value;
		let model = mergeDeep({}, this.context.state.meldingenModel);
		model["meldingInNaamVanAnderePersoon"] = value === "false" ? "true" : "false";
		this.context.setState({
			meldingenModel: model
		});
	}

    addBijlage(event) {
        const currentBijlages = this.context.state.meldingenBijlage;
        const value = event.target.value;
        const toAddItems = [];
        value.forEach(file => {
            if (!this.context.filesHelper.checkIsValidFile(file)) return;

            if (!currentBijlages.length || !currentBijlages.find(x => x.name === file.name)) {
                toAddItems.push(file);
                currentBijlages.push(file);
            }
        });

        this.context.setState({
            meldingenBijlage: currentBijlages,
            hasUnsavedDocumentChanges: true
        });

        if (!this.context.filesHelper.ownerId) {
            this.context.filesHelper.setOwnerId(this.context.state.meldingenModel.id).then(response => {
                this.context.filesHelper.uploadFiles("meldingenBijlage", toAddItems);
            });
        }
        else {
            this.context.filesHelper.uploadFiles("meldingenBijlage", toAddItems);
        }
    }

    removeBijlage(event) {
        const value = event.target.value;
        const currentBijlages = this.context.state.meldingenBijlage;
        const toRemoveItem = currentBijlages.find(x => value.indexOf(x) === -1);

        this.context.setState({
            meldingenBijlage: value,
            hasUnsavedDocumentChanges: true
        });

        if (toRemoveItem) this.context.filesHelper.deleteOneFile("meldingenBijlage", toRemoveItem.name);
    }

	saveAdres(adres) {
		let model = mergeDeep({}, this.context.state.meldingenModel);
		model.adres = adres;

		this.context.setState({
			meldingenModel: model
		});
	}

    save() {
        const context = this.context;
        const state = context.state;
        const ajaxActions = context.props.ajaxActions;

        let modelToSave = state.meldingenModel;
        let documentsForSave = state.meldingenBijlage;

        ajaxActions.started();
        return meldingenApi.saveMelding(modelToSave, documentsForSave)
            .then((response) => {
                ajaxActions.ended();

                if (Object.keys(response.data.validationResults).length === 0 && response.data.hasValidationErrors === false) {
                    context.filesHelper.commitSession();
                }

                this.context.setState({
                    errors: response.data.validationResults,
                    meldingSent: !response.data.hasValidationErrors
                });
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

	onCaptchaVerified(verified) {
		this.context.setState({
			sendButtonDisabled: !verified
		});
	}
}
